export const FLIGHTS = 'Flights';

export const EMPTY_STRING = '';

export const ONEWAY_TEXT = 'One-Way';
export const ONEWAY_TEXT_NEW = 'One Way';
export const ROUNTTRIP_TEXT = 'Round Trip';
export const ROUNTTRIP_TEXT_NEW = 'Return';

export const ONEWAY_JOURNEY_TYPE = 'ow';
export const ROUNDTRIP_JOURNEY_TYPE = 'rt';

export const SOURCE_TEXT = 'From';
export const DESTINATION_TEXT = 'Destination';

export const POPULAR_CITIES = 'Popular Cities';

export const AUTOSUGGEST_PLACEHOLDER = 'Search by location or airport';

export const SOURCE_LOCATION_TYPE = 'src';
export const DESTINATION_LOCATION_TYPE = 'des';

export const DOMESTIC = 'domestic';
export const DOMESTIC_TYPE = 'D';
export const INTERNATIONAL = 'international';
export const INTERNATIONAL_TYPE = 'I';

export const DEPART_TEXT = 'Depart';
export const ARRIVAL_TEXT = 'Return';

export const DEPARTURE_TYPE = 'dep';
export const ARRIVAL_TYPE = 'arr';

export const ONWARD = 'onward';
export const RETURN = 'return';

export const BOOK_ONWARD = 'Book onward';
export const BOOK_RETURN = 'Book return';
export const BOOK_RETURN_NEW = 'Add Return Date';

export const SELECT_DATE = 'Select date';

export const TRAVELLERS_TEXT = { english: 'Travellers', hindi: 'यात्रियों' };
export const ADULT = 'Adult';
export const CHILD = 'Child';
export const INFANT = 'Infant';

export const FLIGHT_CLASS_TEXT = { english: 'Class', hindi: 'कक्षा' };

export const FILTER_HEADER_TEXT = 'Filters';
export const NON_STOP = 'Non Stop';

export const SEARCH_TEXT = 'SEARCH';

export const UPDATE_SEARCH_TEXT = {
  english: 'UPDATE SEARCH',
  hindi: 'आगे बढ़े'
};

export const FLIGHT_STATUS_BANNER = 'Check Flight Status';
export const FLIGHT_STATUS_BANNER_SUB_TEXT = 'for Arrival time, Delays, Cancellation etc.';

export const RECENT_SEARCH_HEADER_TEXT = 'Recent Searches';
export const RECENT_SEARCH_LOCAL_STORAGE_KEY = 'rsFlt';
export const SEARCHED_CITIES_LOCAL_STORAGE_KEY = 'searchedCities';

export const OFFERS_HEADER_TEXT = 'Offers';

export const CANCEL = 'Cancel';
export const OK = 'Ok';

export const ANYTIME_TEXT = 'Anytime in the next 6 months';

export const FREE_TEXT = 'Free';
export const PAID_TEXT = 'Paid';
export const SEAT_TEXT = 'Seat';
export const ADDED_TEXT = 'Added';

export const FLIGHT_CLASS_OBJECT: Array<{ value: string; name: string }> = [
  { value: 'E', name: 'Economy' },
  { value: 'B', name: 'Business' },
  { value: 'F', name: 'First class' },
  { value: 'W', name: 'Premium Economy' }
];

export const PAX_DETAILS: object = {
  english: {
    adult: {
      name: ADULT,
      text: '12+ years'
    },
    child: {
      name: CHILD,
      text: '2 - 12 years'
    },
    infant: {
      name: INFANT,
      text: 'below 2 years'
    }
  },
  hindi: {
    adult: {
      name: 'वयस्क',
      text: '12+ वर्ष'
    },
    child: {
      name: 'बच्चे',
      text: '2 - 12 वर्ष'
    },
    infant: {
      name: 'शिशु',
      text: 'दो साल से कम'
    }
  }
};

export const spriteClasses = [
  'carrier6E',
  'carrierSG',
  'carrierI5',
  'carrierIX',
  'carrierG8',
  'carrierUK',
  'carrierAI',
  'carrier2T',
  'carrier9I',
  'carrierS5',
  'carrierQP'
];

export const domesticAirlines = [
  'trujet',
  'indigo',
  'goair',
  'air-india',
  'spicejet',
  'airasia',
  'akasa-air'
];

const journeyType_text_hindi = {
  ONEWAY_TEXT: 'एकतरफ़ा',
  ROUNTTRIP_TEXT: 'वापसी यात्रा'
};

export const ONEWAY_AND_ROUNTTRIP_TEXT = {
  english: {
    ONEWAY_TEXT: 'One Way Trip',
    ROUNTTRIP_TEXT: 'Round Trip'
  },
  hindi: journeyType_text_hindi
};

export const ONEWAY_AND_ROUNTTRIP_TEXT_NEW = {
  english: {
    ONEWAY_TEXT: ONEWAY_TEXT_NEW,
    ROUNTTRIP_TEXT: ROUNTTRIP_TEXT_NEW
  },
  hindi: journeyType_text_hindi
};

export const SOURCE_AND_DESTINATION_TEXT = {
  english: {
    SOURCE_TEXT: 'From',
    DESTINATION_TEXT: 'Destination'
  },
  hindi: {
    SOURCE_TEXT: 'से',
    DESTINATION_TEXT: 'से'
  }
};

export const SOURCE_AND_DESTINATION_TEXT_FOR_DWEB = {
  english: {
    SOURCE_TEXT: 'FROM',
    DESTINATION_TEXT: 'TO'
  },
  hindi: {
    SOURCE_TEXT: 'से',
    DESTINATION_TEXT: 'से'
  }
};

export const DEPARTURE_AND_ARRIVAL_TEXT = {
  english: {
    DEPART_TEXT: 'Depart',
    ARRIVAL_TEXT: 'Return'
  },
  hindi: {
    DEPART_TEXT: 'रवाना होना',
    ARRIVAL_TEXT: 'वापसी'
  }
};

export const DEPARTURE_AND_ARRIVAL_TEXT_FOR_DWEB = {
  english: {
    DEPART_TEXT: 'DEPARTURE DATE',
    ARRIVAL_TEXT: 'RETURN DATE'
  },
  hindi: {
    DEPART_TEXT: 'रवाना होना',
    ARRIVAL_TEXT: 'वापसी'
  }
};

export const PASSENGER_AND_CLASS_TEXT_FOR_DWEB = {
  english: 'PASSENGER & CLASS',
  hindi: 'यात्रियों और कक्षा'
};

export const TRAVEL_CLASS_TEXT = {
  english: 'Travel Class',
  hindi: 'यात्रा कक्ष चुनें'
};

export const DONE_TEXT = {
  english: 'Done',
  hindi: 'आगे बढ़े'
};

export const FLIGHTS_TEXT = {
  english: 'Flights',
  hindi: 'उड़ान'
};

export const FLIGHT_SCHEDULE_TEXT = {
  english: 'Flight Schedule',
  hindi: 'उड़ान अनुसूची'
};

export const TO = {
  english: 'to',
  hindi: 'से'
};

export const LOWEST_FARE_TEXT = {
  english: 'Lowest Fare Rs.',
  hindi: 'न्यूनतम किराया ₹'
};

export const CHEAP_FLIGHT_FARE_TEXT = {
  english: 'Cheap Flights Fares',
  hindi: 'सस्ता उड़ान किराया'
};

export const SIGN_UP_TEXT = 'SIGN UP';

export const FARE_OPTIONS = [
  // {
  //   text: 'Regular',
  //   subtext: '',
  //   identifier: 'R'
  // },
  {
    text: 'Senior Citizen',
    subtext: 'Age above 60 yrs',
    identifier: 'SC',
    oldIdentifier: 'ft=sc',
    icon: 'https://gos3.ibcdn.com/senior-1628684269.png',
    isnew: true
  },
  {
    text: 'Student',
    subtext: 'ID required',
    identifier: 'ST',
    oldIdentifier: 'student=true',
    icon: 'https://gos3.ibcdn.com/student-1628684284.png'
  },
  {
    text: 'Defence',
    subtext: 'ID required',
    identifier: 'AF',
    oldIdentifier: 'ft=a',
    icon: 'https://gos3.ibcdn.com/defence-1628754836.png',
    isnew: true
  }
];

export const REPLACER = '{{replacer}}';

export const CANCELLATION_ID = 'cancellation';

export const DATE_CHANGE_ID = 'date_change';
